// SSM Error Management
enum SSMError {
  'ssmsetuperror' = -1352,
  'ssmrenewalerror' = -1353,
  'ssmteardownerror' = -1354
}

enum SessionErrorId {
  SessionCreationFailure = "SessionCreationFailure", // 1352
  SessionRenewalFailure = "SessionRenewalFailure", // 1353
  SessionTeardownFailure = "SessionTeardownFailure", // 1354
  SessionErrorInvalidRequest = "SessionErrorInvalidRequest", // 1000, 1011
  SessionErrorDeviceUuid = "SessionErrorDeviceUuid", // 1001
  SessionErrorInvalidToken = "SessionErrorInvalidToken", // 1003, 1006
  SessionErrorInvalidExpirationTime = "SessionErrorInvalidExpirationTime", // 1004
  SessionErrorInvalidConfig = "SessionErrorInvalidConfig", // 1005
  SessionErrorMaxSession = "SessionErrorMaxSession", // 1007
  SessionErrorSessionManagementDisabled = "SessionErrorSessionManagementDisabled", // 1008
  SessionErrorInvalidDevice = "SessionErrorInvalidDevice", // 1009
  SessionErrorBadRequest = "SessionErrorBadRequest", // 1011
  SessionErrorKeyError = "SessionErrorKeyError", // 1012
  SessionErrorMissingDeviceId = "SessionErrorMissingDeviceId", // 1013
  SessionErrorInvalidExternalID = "SessionErrorInvalidExternalID", // 1017
  SessionErrorExternalIDAlreadyUsed = "SessionErrorExternalIDAlreadyUsed", // 1018
  SessionErrorUnknownAccount = "SessionErrorUnknownAccount", // 3001
  SessionErrorUnknownDevice = "SessionErrorUnknownDevice", // 3004
  SessionErrorInternalError = "SessionErrorInternalError", // 4000
  SessionErrorSSMNotAvailable = "SessionErrorSSMNotAvailable", // 4001
  SessionUnknownError = "SessionUnknownError"
}

function SSMCodeToRawCode(code: number, suffix: string | undefined): string {

  if (!suffix) {
    return SessionErrorId.SessionUnknownError; // 9999
  }

  switch (code) {
    case SSMError.ssmsetuperror:
      switch (suffix) {
        case 'A': return SessionErrorId.SessionErrorDeviceUuid; // 1001
        case 'B': return SessionErrorId.SessionErrorInvalidToken; // 1003, 1006
        case 'C': return SessionErrorId.SessionErrorInvalidExpirationTime; // 1004
        case 'D': return SessionErrorId.SessionErrorInvalidConfig; // 1005
        case 'E': return SessionErrorId.SessionErrorInvalidToken; // 1006, 1003
        case 'F': return SessionErrorId.SessionErrorMaxSession; // 1007
        case 'G': return SessionErrorId.SessionErrorSessionManagementDisabled; // 1008
        case 'H': return SessionErrorId.SessionErrorInvalidDevice; // 1009
        case 'I': return SessionErrorId.SessionErrorInvalidRequest; // 1000
        case 'J': return SessionErrorId.SessionErrorBadRequest; // 1011
        case 'K': return SessionErrorId.SessionErrorKeyError; // 1012
        case 'L': return SessionErrorId.SessionErrorMissingDeviceId; // 1013
        case 'M': return SessionErrorId.SessionErrorInvalidExternalID; // 1017
        case 'N': return SessionErrorId.SessionErrorExternalIDAlreadyUsed; // 1018
        case 'O': return SessionErrorId.SessionErrorUnknownAccount; // 3001
        case 'P': return SessionErrorId.SessionErrorUnknownDevice; // 3004
        case 'Q': return SessionErrorId.SessionErrorInternalError; // 4000
        case 'R': return SessionErrorId.SessionErrorSSMNotAvailable; // 4001
        default: return SessionErrorId.SessionCreationFailure; // 1352
      }

    case SSMError.ssmteardownerror:
      switch (suffix) {
        case 'A': return SessionErrorId.SessionErrorDeviceUuid; // 1001
        case 'B': return SessionErrorId.SessionErrorInvalidToken; // 1003, 1006
        case 'C': return SessionErrorId.SessionErrorInvalidExpirationTime; // 1004
        case 'D': return SessionErrorId.SessionErrorInvalidConfig; // 1005
        case 'E': return SessionErrorId.SessionErrorInvalidToken; // 1006, 1003
        case 'F': return SessionErrorId.SessionErrorMaxSession; // 1007
        case 'G': return SessionErrorId.SessionErrorSessionManagementDisabled; // 1008
        case 'H': return SessionErrorId.SessionErrorInvalidDevice; // 1009
        case 'I': return SessionErrorId.SessionErrorInvalidRequest; // 1000
        case 'J': return SessionErrorId.SessionErrorBadRequest; // 1011
        case 'K': return SessionErrorId.SessionErrorKeyError; // 1012
        case 'L': return SessionErrorId.SessionErrorMissingDeviceId; // 1013
        case 'M': return SessionErrorId.SessionErrorInvalidExternalID; // 1017
        case 'N': return SessionErrorId.SessionErrorExternalIDAlreadyUsed; // 1018
        case 'O': return SessionErrorId.SessionErrorUnknownAccount; // 3001
        case 'P': return SessionErrorId.SessionErrorUnknownDevice; // 3004
        case 'Q': return SessionErrorId.SessionErrorInternalError; // 4000
        case 'R': return SessionErrorId.SessionErrorSSMNotAvailable; // 4001
        default: return SessionErrorId.SessionTeardownFailure; // 1354
      }

    case SSMError.ssmrenewalerror:
      switch (suffix) {
        case 'A': return SessionErrorId.SessionErrorDeviceUuid; // 1001
        case 'B': return SessionErrorId.SessionErrorInvalidToken; // 1003, 1006
        case 'C': return SessionErrorId.SessionErrorInvalidExpirationTime; // 1004
        case 'D': return SessionErrorId.SessionErrorInvalidConfig; // 1005
        case 'E': return SessionErrorId.SessionErrorInvalidToken; // 1006, 1003
        case 'F': return SessionErrorId.SessionErrorMaxSession; // 1007
        case 'G': return SessionErrorId.SessionErrorSessionManagementDisabled; // 1008
        case 'H': return SessionErrorId.SessionErrorInvalidDevice; // 1009
        case 'I': return SessionErrorId.SessionErrorInvalidRequest; // 1000
        case 'J': return SessionErrorId.SessionErrorBadRequest; // 1011
        case 'K': return SessionErrorId.SessionErrorKeyError; // 1012
        case 'L': return SessionErrorId.SessionErrorMissingDeviceId; // 1013
        case 'M': return SessionErrorId.SessionErrorInvalidExternalID; // 1017
        case 'N': return SessionErrorId.SessionErrorExternalIDAlreadyUsed; // 1018
        case 'O': return SessionErrorId.SessionErrorUnknownAccount; // 3001
        case 'P': return SessionErrorId.SessionErrorUnknownDevice; // 3004
        case 'Q': return SessionErrorId.SessionErrorInternalError; // 4000
        case 'R': return SessionErrorId.SessionErrorSSMNotAvailable; // 4001
        default: return SessionErrorId.SessionRenewalFailure; // 1353
      }

    default:
      return SessionErrorId.SessionUnknownError; // 9999
  }
}

export const ssmErrorCodes: { [key: number]: string } = {
  1001: 'A', // Device_uid mismatch
  1003: 'B', // Invalid authentication token
  1004: 'C', // Invalid expiration time
  1005: 'D', // Tenant ID mismatch
  1006: 'E', // Invalid token
  1007: 'F', // Max active sessions exceeded
  1008: 'G', // Session management disabled
  1009: 'H', // Device account mismatch
  1000: 'I', // Invalid request format
  1011: 'J', // Bad request
  1012: 'K', // Credential key not available
  1013: 'L', // Missing Device Id
  1017: 'M', // Invalid external session ID length
  1018: 'N', // External session ID already in use
  3001: 'O', // Unknown account
  3004: 'P', // Unknown device
  4000: 'Q', // Internal error
  4001: 'R', // SSM not available
};

export const ssmError: { [key: string]: number } = {
  "ssmsetuperror": SSMError.ssmsetuperror,
  "ssmrenewalerror":SSMError.ssmrenewalerror,
  "ssmteardownerror": SSMError.ssmteardownerror,
}

const ErrorCode = {
  "UNSUPPORTED_SCHEME": 1000,
  "BAD_HTTP_STATUS": 1001,
  "HTTP_ERROR": 1002,
  "TIMEOUT": 1003,
  "MALFORMED_DATA_URI": 1004,
  "REQUEST_FILTER_ERROR": 1006,
  "RESPONSE_FILTER_ERROR": 1007,
  "MALFORMED_TEST_URI": 1008,
  "UNEXPECTED_TEST_REQUEST": 1009,
  "ATTEMPTS_EXHAUSTED": 1010,
  "SEGMENT_MISSING": 1011,
  "INVALID_TEXT_HEADER": 2000,
  "INVALID_TEXT_CUE": 2001,
  "UNABLE_TO_DETECT_ENCODING": 2003,
  "BAD_ENCODING": 2004,
  "INVALID_XML": 2005,
  "INVALID_MP4_TTML": 2007,
  "INVALID_MP4_VTT": 2008,
  "UNABLE_TO_EXTRACT_CUE_START_TIME": 2009,
  "INVALID_MP4_CEA": 2010,
  "TEXT_COULD_NOT_GUESS_MIME_TYPE": 2011,
  "CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS": 2012,
  "TEXT_ONLY_WEBVTT_SRC_EQUALS": 2013,
  "MISSING_TEXT_PLUGIN": 2014,
  "CHAPTERS_TRACK_FAILED": 2015,
  "UNSUPPORTED_EXTERNAL_THUMBNAILS_URI": 2017,
  "BUFFER_READ_OUT_OF_BOUNDS": 3000,
  "JS_INTEGER_OVERFLOW": 3001,
  "EBML_OVERFLOW": 3002,
  "EBML_BAD_FLOATING_POINT_SIZE": 3003,
  "MP4_SIDX_WRONG_BOX_TYPE": 3004,
  "MP4_SIDX_INVALID_TIMESCALE": 3005,
  "MP4_SIDX_TYPE_NOT_SUPPORTED": 3006,
  "WEBM_CUES_ELEMENT_MISSING": 3007,
  "WEBM_EBML_HEADER_ELEMENT_MISSING": 3008,
  "WEBM_SEGMENT_ELEMENT_MISSING": 3009,
  "WEBM_INFO_ELEMENT_MISSING": 3010,
  "WEBM_DURATION_ELEMENT_MISSING": 3011,
  "WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING": 3012,
  "WEBM_CUE_TIME_ELEMENT_MISSING": 3013,
  "MEDIA_SOURCE_OPERATION_FAILED": 3014,
  "MEDIA_SOURCE_OPERATION_THREW": 3015,
  "VIDEO_ERROR": 3016,
  "QUOTA_EXCEEDED_ERROR": 3017,
  "TRANSMUXING_FAILED": 3018,
  "CONTENT_TRANSFORMATION_FAILED": 3019,
  "MSS_MISSING_DATA_FOR_TRANSMUXING": 3020,
  "MSS_TRANSMUXING_CODEC_UNKNOWN": 3021,
  "MSS_TRANSMUXING_FAILED": 3022,
  "TRANSMUXING_NO_VIDEO_DATA": 3023,
  "UNABLE_TO_GUESS_MANIFEST_TYPE": 4000,
  "DASH_INVALID_XML": 4001,
  "DASH_NO_SEGMENT_INFO": 4002,
  "DASH_EMPTY_ADAPTATION_SET": 4003,
  "DASH_EMPTY_PERIOD": 4004,
  "DASH_WEBM_MISSING_INIT": 4005,
  "DASH_UNSUPPORTED_CONTAINER": 4006,
  "DASH_PSSH_BAD_ENCODING": 4007,
  "DASH_NO_COMMON_KEY_SYSTEM": 4008,
  "DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED": 4009,
  "DASH_CONFLICTING_KEY_IDS": 4010,
  "RESTRICTIONS_CANNOT_BE_MET": 4012,
  "HLS_PLAYLIST_HEADER_MISSING": 4015,
  "INVALID_HLS_TAG": 4016,
  "HLS_INVALID_PLAYLIST_HIERARCHY": 4017,
  "DASH_DUPLICATE_REPRESENTATION_ID": 4018,
  "HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND": 4020,
  "HLS_REQUIRED_ATTRIBUTE_MISSING": 4023,
  "HLS_REQUIRED_TAG_MISSING": 4024,
  "HLS_COULD_NOT_GUESS_CODECS": 4025,
  "HLS_KEYFORMATS_NOT_SUPPORTED": 4026,
  "DASH_UNSUPPORTED_XLINK_ACTUATE": 4027,
  "DASH_XLINK_DEPTH_LIMIT": 4028,
  "CONTENT_UNSUPPORTED_BY_BROWSER": 4032,
  "CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM": 4033,
  "NO_VARIANTS": 4036,
  "PERIOD_FLATTENING_FAILED": 4037,
  "INCONSISTENT_DRM_ACROSS_PERIODS": 4038,
  "HLS_VARIABLE_NOT_FOUND": 4039,
  "HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED": 4040,
  "HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED": 4041,
  "NO_WEB_CRYPTO_API": 4042,
  "CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM": 4045,
  "MSS_INVALID_XML": 4046,
  "MSS_LIVE_CONTENT_NOT_SUPPORTED": 4047,
  "AES_128_INVALID_IV_LENGTH": 4048,
  "AES_128_INVALID_KEY_LENGTH": 4049,
  "DASH_CONFLICTING_AES_128": 4050,
  "DASH_UNSUPPORTED_AES_128": 4051,
  "STREAMING_ENGINE_STARTUP_INVALID_STATE": 5006,
  "NO_RECOGNIZED_KEY_SYSTEMS": 6000,
  "REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE": 6001,
  "FAILED_TO_CREATE_CDM": 6002,
  "FAILED_TO_ATTACH_TO_VIDEO": 6003,
  "INVALID_SERVER_CERTIFICATE": 6004,
  "FAILED_TO_CREATE_SESSION": 6005,
  "FAILED_TO_GENERATE_LICENSE_REQUEST": 6006,
  "LICENSE_REQUEST_FAILED": 6007,
  "LICENSE_RESPONSE_REJECTED": 6008,
  "ENCRYPTED_CONTENT_WITHOUT_DRM_INFO": 6010,
  "NO_LICENSE_SERVER_GIVEN": 6012,
  "OFFLINE_SESSION_REMOVED": 6013,
  "EXPIRED": 6014,
  "SERVER_CERTIFICATE_REQUIRED": 6015,
  "INIT_DATA_TRANSFORM_ERROR": 6016,
  "SERVER_CERTIFICATE_REQUEST_FAILED": 6017,
  "MIN_HDCP_VERSION_NOT_MATCH": 6018,
  "ERROR_CHECKING_HDCP_VERSION": 6019,
  "LOAD_INTERRUPTED": 7000,
  "OPERATION_ABORTED": 7001,
  "NO_VIDEO_ELEMENT": 7002,
  "OBJECT_DESTROYED": 7003,
  "CONTENT_NOT_LOADED": 7004,
  "CAST_API_UNAVAILABLE": 8000,
  "NO_CAST_RECEIVERS": 8001,
  "ALREADY_CASTING": 8002,
  "UNEXPECTED_CAST_ERROR": 8003,
  "CAST_CANCELED_BY_USER": 8004,
  "CAST_CONNECTION_TIMED_OUT": 8005,
  "CAST_RECEIVER_APP_UNAVAILABLE": 8006,
  "STORAGE_NOT_SUPPORTED": 9000,
  "INDEXED_DB_ERROR": 9001,
  "DEPRECATED_OPERATION_ABORTED": 9002,
  "REQUESTED_ITEM_NOT_FOUND": 9003,
  "MALFORMED_OFFLINE_URI": 9004,
  "CANNOT_STORE_LIVE_OFFLINE": 9005,
  "NO_INIT_DATA_FOR_OFFLINE": 9007,
  "LOCAL_PLAYER_INSTANCE_REQUIRED": 9008,
  "NEW_KEY_OPERATION_NOT_SUPPORTED": 9011,
  "KEY_NOT_FOUND": 9012,
  "MISSING_STORAGE_CELL": 9013,
  "STORAGE_LIMIT_REACHED": 9014,
  "DOWNLOAD_SIZE_CALLBACK_ERROR": 9015,
  "MODIFY_OPERATION_NOT_SUPPORTED": 9016,
  "INDEXED_DB_INIT_TIMED_OUT": 9017,
  "CS_IMA_SDK_MISSING": 10000,
  "CS_AD_MANAGER_NOT_INITIALIZED": 10001,
  "SS_IMA_SDK_MISSING": 10002,
  "SS_AD_MANAGER_NOT_INITIALIZED": 10003,
  "CURRENT_DAI_REQUEST_NOT_FINISHED": 10004,
  "MT_AD_MANAGER_NOT_INITIALIZED": 10005,
  "PLAYER_DRM_FETCH_FAILURE": 370
};

export const playerCodeToVoltCode = (code: any, suffix?: string): String => {
  // https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
  switch (code) {
    case ErrorCode.UNSUPPORTED_SCHEME:
      return "PlayerNetworkUnsupportedscheme";
    case ErrorCode.BAD_HTTP_STATUS:
      return "PlayerNetworkBadHttpStatus";
    case ErrorCode.HTTP_ERROR:
      return "PlayerNetworkHttpError";
    case ErrorCode.TIMEOUT:
      return "PlayerNetworkNetworkrequesttimedout";
    case ErrorCode.MALFORMED_DATA_URI:
      return "PlayerNetworkMalformedDataURI";
    case ErrorCode.REQUEST_FILTER_ERROR:
      return "PlayerNetworkRequestFilterError";
    case ErrorCode.RESPONSE_FILTER_ERROR:
      return "PlayerNetworkResponseFilterError";
    case ErrorCode.MALFORMED_TEST_URI:
      return "PlayerNetworkMalformedTestUri";
    case ErrorCode.UNEXPECTED_TEST_REQUEST:
      return "PlayerNetworkUnexpectedTestRequest";
    case ErrorCode.ATTEMPTS_EXHAUSTED:
      return "PlayerNetworkAttemptsExhausted";
    case ErrorCode.SEGMENT_MISSING:
      return "PlayerNetworkSegmentIsMissing";
    case ErrorCode.INVALID_TEXT_HEADER:
      return "PlayerTextParsingInvalidHeader";
    case ErrorCode.INVALID_TEXT_CUE:
      return "PlayerTextParsingInvalidCue";
    case ErrorCode.UNABLE_TO_DETECT_ENCODING:
      return "PlayerTextParsingUnableToDetecttheEncoding";
    case ErrorCode.BAD_ENCODING:
      return "PlayerTextParsingBadEncoding";
    case ErrorCode.INVALID_XML:
      return "PlayerTextParsingInvalidXML";
    case ErrorCode.INVALID_MP4_TTML:
      return "PlayerTextParsingInvalidMP4TTML";
    case ErrorCode.INVALID_MP4_VTT:
      return "PlayerTextParsingInvalidMP4VTT";
    case ErrorCode.UNABLE_TO_EXTRACT_CUE_START_TIME:
      return "PlayerTextParsingUnableToExtractCueStartTime";
    case ErrorCode.INVALID_MP4_CEA:
      return "PlayerTextParsingInvalidMP4CEA";
    case ErrorCode.TEXT_COULD_NOT_GUESS_MIME_TYPE:
      return "PlayerTextParsingTextCouldNotGuessMineType";
    case ErrorCode.CANNOT_ADD_EXTERNAL_TEXT_TO_SRC_EQUALS:
      return "PlayerTextParsingCanNotAddExternalTextToSrcEquals";
    case ErrorCode.TEXT_ONLY_WEBVTT_SRC_EQUALS:
      return "PlayerTextParsingTextOnlyWebVTTSrcEquals";
    case ErrorCode.MISSING_TEXT_PLUGIN:
      return "PlayerTextParsingMissingTextPlugin";
    case ErrorCode.CHAPTERS_TRACK_FAILED:
      return "PlayerTextParsingChaptersTrackFailed";
    case ErrorCode.UNSUPPORTED_EXTERNAL_THUMBNAILS_URI:
      return "PlayerTextParsingUnsupportedExternalThumbnailsUri";
    case ErrorCode.BUFFER_READ_OUT_OF_BOUNDS:
      return "PlayerMediaBufferReadOutOfBounds";
    case ErrorCode.JS_INTEGER_OVERFLOW:
      return "PlayerMediaJsIntegerOverflow";
    case ErrorCode.EBML_OVERFLOW:
      return "PlayerMediaEBMLOverlow";
    case ErrorCode.EBML_BAD_FLOATING_POINT_SIZE:
      return "PlayerMediaEBMLBadFloatingPointSize";
    case ErrorCode.MP4_SIDX_WRONG_BOX_TYPE:
      return "PlayerMediaMP4SIDXWrongBoxType";
    case ErrorCode.MP4_SIDX_INVALID_TIMESCALE:
      return "PlayerMediaMP4SIDXInvalidTimeScale";
    case ErrorCode.MP4_SIDX_TYPE_NOT_SUPPORTED:
      return "PlayerMediaMP4SIDXTypeNotSupported";
    case ErrorCode.WEBM_CUES_ELEMENT_MISSING:
      return "PlayerMediaWEBMCuesElementMissing";
    case ErrorCode.WEBM_EBML_HEADER_ELEMENT_MISSING:
      return "PlayerMediaWEBMEBMLHeaderElementMissing";
    case ErrorCode.WEBM_SEGMENT_ELEMENT_MISSING:
      return "PlayerMediaWEBMSegmentElementMissing";
    case ErrorCode.WEBM_INFO_ELEMENT_MISSING:
      return "PlayerMediaWEBMInfoElementMissing";
    case ErrorCode.WEBM_DURATION_ELEMENT_MISSING:
      return "PlayerMediaWEBMDurationElementMissing";
    case ErrorCode.WEBM_CUE_TRACK_POSITIONS_ELEMENT_MISSING:
      return "PlayerMediaWEBMCueTrackPositionsElementMissing";
    case ErrorCode.WEBM_CUE_TIME_ELEMENT_MISSING:
      return "PlayerMediaWEBMCueTimeElementMissing";
    case ErrorCode.MEDIA_SOURCE_OPERATION_FAILED:
      return "PlayerMediaMediaSourceOperationFailed";
    case ErrorCode.MEDIA_SOURCE_OPERATION_THREW:
      return "PlayerMediaMediaSourceOperationThrew";
    case ErrorCode.VIDEO_ERROR:
      return "PlayerMediaVideoError";
    case ErrorCode.QUOTA_EXCEEDED_ERROR:
      return "PlayerMediaQuotaExceededError";
    case ErrorCode.TRANSMUXING_FAILED:
      return "PlayerMediaTransmuxingFailed";
    case ErrorCode.CONTENT_TRANSFORMATION_FAILED:
      return "PlayerMediaContentTransformationFailed";
    case ErrorCode.MSS_MISSING_DATA_FOR_TRANSMUXING:
      return "PlayerMediaMSSMissingDataForTransmuxing";
    case ErrorCode.MSS_TRANSMUXING_CODEC_UNKNOWN:
      return "PlayerMediaMSSTransmuxingCodecUnknown";
    case ErrorCode.MSS_TRANSMUXING_FAILED:
      return "PlayerMediaMSSTransmuxingFailed";
    case ErrorCode.TRANSMUXING_NO_VIDEO_DATA:
      return "PlayerMediaTransmuxingNoVideoData";
    case ErrorCode.UNABLE_TO_GUESS_MANIFEST_TYPE:
      return "PlayerManifestUnableToGuessManifestType";
    case ErrorCode.DASH_INVALID_XML:
      return "PlayerManifestDashInvalidXML";
    case ErrorCode.DASH_NO_SEGMENT_INFO:
      return "PlayerManifestDashNoSegmentInfo";
    case ErrorCode.DASH_EMPTY_ADAPTATION_SET:
      return "PlayerManifestDashEmptyAdaptationSet";
    case ErrorCode.DASH_EMPTY_PERIOD:
      return "PlayerManifestDashEmptyPeriod";
    case ErrorCode.DASH_WEBM_MISSING_INIT:
      return "PlayerManifestDashWEBMMissingInit";
    case ErrorCode.DASH_UNSUPPORTED_CONTAINER:
      return "PlayerManifestDashUnsupportedContainer";
    case ErrorCode.DASH_PSSH_BAD_ENCODING:
      return "PlayerManifestDashPSSHBadEncoding";
    case ErrorCode.DASH_NO_COMMON_KEY_SYSTEM:
      return "PlayerManifestDashNoCommonKeySystem";
    case ErrorCode.DASH_MULTIPLE_KEY_IDS_NOT_SUPPORTED:
      return "PlayerManifestDashMultipleKeyIdsNotSupported";
    case ErrorCode.DASH_CONFLICTING_KEY_IDS:
      return "PlayerManifestDashConflictingKeyIds";
    case ErrorCode.RESTRICTIONS_CANNOT_BE_MET:
      return "PlayerManifestRestrictionsCannotBeMet";
    case ErrorCode.HLS_PLAYLIST_HEADER_MISSING:
      return "PlayerManifestHLSPlaylistHeaderMissing";
    case ErrorCode.INVALID_HLS_TAG:
      return "PlayerManifestInvalidHLSTag";
    case ErrorCode.HLS_INVALID_PLAYLIST_HIERARCHY:
      return "PlayerManifestHLSInvalidPlaylistHierarchy";
    case ErrorCode.DASH_DUPLICATE_REPRESENTATION_ID:
      return "PlayerManifestDashDuplicateRepresentationId";
    case ErrorCode.HLS_MULTIPLE_MEDIA_INIT_SECTIONS_FOUND:
      return "PlayerManifestHLSMultipleMediaInitSectionsFound";
    case ErrorCode.HLS_REQUIRED_ATTRIBUTE_MISSING:
      return "PlayerManifestHLSRequiredAttributeMissing";
    case ErrorCode.HLS_REQUIRED_TAG_MISSING:
      return "PlayerManifestHLSRequiredTagMissing";
    case ErrorCode.HLS_COULD_NOT_GUESS_CODECS:
      return "PlayerManifestHLSCouldNotGuessCodecs";
    case ErrorCode.HLS_KEYFORMATS_NOT_SUPPORTED:
      return "PlayerManifestHLSKeyFormatsNotSupported";
    case ErrorCode.DASH_UNSUPPORTED_XLINK_ACTUATE:
      return "PlayerManifestDashUnsupportedXlinkActuate";
    case ErrorCode.DASH_XLINK_DEPTH_LIMIT:
      return "PlayerManifestDashXlinkDepthLimit";
    case ErrorCode.CONTENT_UNSUPPORTED_BY_BROWSER:
      return "PlayerManifestContentUnsupportedByBrowser";
    case ErrorCode.CANNOT_ADD_EXTERNAL_TEXT_TO_LIVE_STREAM:
      return "PlayerManifestCannotAddExternalTextToLiveStream";
    case ErrorCode.NO_VARIANTS:
      return "PlayerManifestNoVariants";
    case ErrorCode.PERIOD_FLATTENING_FAILED:
      return "PlayerManifestPeriodFlatteningFailed";
    case ErrorCode.INCONSISTENT_DRM_ACROSS_PERIODS:
      return "PlayerManifestInconsistentDRMAcrossPeriods";
    case ErrorCode.HLS_VARIABLE_NOT_FOUND:
      return "PlayerManifestHLSVariableNotFound";
    case ErrorCode.HLS_MSE_ENCRYPTED_MP2T_NOT_SUPPORTED:
      return "PlayerManifestHLSMSEEncryptedMP2TNotSupported";
    case ErrorCode.HLS_MSE_ENCRYPTED_LEGACY_APPLE_MEDIA_KEYS_NOT_SUPPORTED:
      return "PlayerManifestHLSMSEEncryptedLegacyAppleMediaKeysNotSupported";
    case ErrorCode.NO_WEB_CRYPTO_API:
      return "PlayerManifestNoWebCryptoApi";
    case ErrorCode.CANNOT_ADD_EXTERNAL_THUMBNAILS_TO_LIVE_STREAM:
      return "PlayerManifestCanNotAddExternalThumbnailsToLiveStream";
    case ErrorCode.MSS_INVALID_XML:
      return "PlayerManifestMSSInvalidXML";
    case ErrorCode.MSS_LIVE_CONTENT_NOT_SUPPORTED:
      return "PlayerManifestMSSLiveContentNotSupported";
    case ErrorCode.AES_128_INVALID_IV_LENGTH:
      return "PlayerManifestAES128InvalidIVLength";
    case ErrorCode.AES_128_INVALID_KEY_LENGTH:
      return "PlayerManifestAES128InvalidKeyLength";
    case ErrorCode.DASH_CONFLICTING_AES_128:
      return "PlayerManifestDashConflictingAES128";
    case ErrorCode.DASH_UNSUPPORTED_AES_128:
      return "PlayerManifestDashUnsupportedAES128";
    case ErrorCode.STREAMING_ENGINE_STARTUP_INVALID_STATE:
      return "PlayerStreamingStreamingEngineStartupInvalidState";
    case ErrorCode.NO_RECOGNIZED_KEY_SYSTEMS:
      return "PlayerDRMNoRecognizedKeySystems";
    case ErrorCode.REQUESTED_KEY_SYSTEM_CONFIG_UNAVAILABLE:
      return "PlayerDRMRequestedKeySystemConfigUnavailable";
    case ErrorCode.FAILED_TO_CREATE_CDM:
      return "PlayerDRMFailedToCreateCDM";
    case ErrorCode.FAILED_TO_ATTACH_TO_VIDEO:
      return "PlayerDRMFailedToAttachToVideo";
    case ErrorCode.INVALID_SERVER_CERTIFICATE:
      return "PlayerDRMInvalidServerCertificate";
    case ErrorCode.FAILED_TO_CREATE_SESSION:
      return "PlayerDRMFailedToCreateSession";
    case ErrorCode.FAILED_TO_GENERATE_LICENSE_REQUEST:
      return "PlayerDRMFailedToGenerateLicenseRequest";
    case ErrorCode.LICENSE_REQUEST_FAILED:
      return "PlayerDRMLicenseRequestFailed";
    case ErrorCode.LICENSE_RESPONSE_REJECTED:
      return "PlayerDRMLicenseResponseRejected";
    case ErrorCode.ENCRYPTED_CONTENT_WITHOUT_DRM_INFO:
      return "PlayerDRMEncryptedContentWithoutDRMInfo";
    case ErrorCode.NO_LICENSE_SERVER_GIVEN:
      return "PlayerDRMNoLicenseServerGiven";
    case ErrorCode.OFFLINE_SESSION_REMOVED:
      return "PlayerDRMOfflineSessionRemoved";
    case ErrorCode.EXPIRED:
      return "PlayerDRMLicenseHasExpired";
    case ErrorCode.SERVER_CERTIFICATE_REQUIRED:
      return "PlayerDRMServerCertificateRequired";
    case ErrorCode.INIT_DATA_TRANSFORM_ERROR:
      return "PlayerDRMInitDataTransformError";
    case ErrorCode.SERVER_CERTIFICATE_REQUEST_FAILED:
      return "PlayerDRMServerCertificateRequestFailed";
    case ErrorCode.MIN_HDCP_VERSION_NOT_MATCH:
      return "PlayerDRMMinHDCPVersionNotMatch";
    case ErrorCode.ERROR_CHECKING_HDCP_VERSION:
      return "PlayerDRMErrorCheckingHDCPVersion";
    case ErrorCode.LOAD_INTERRUPTED:
      return "PlayerMiscellaneousLoadInterrupted";
    case ErrorCode.OPERATION_ABORTED:
      return "PlayerMiscellaneousOperationAborted";
    case ErrorCode.NO_VIDEO_ELEMENT:
      return "PlayerMiscellaneousNoVideoElement";
    case ErrorCode.OBJECT_DESTROYED:
      return "PlayerMiscellaneousObjectDestroyed";
    case ErrorCode.CONTENT_NOT_LOADED:
      return "PlayerMiscellaneousContentNotLoaded";
    case ErrorCode.CAST_API_UNAVAILABLE:
      return "PlayerCastCastAPIUnavailable";
    case ErrorCode.NO_CAST_RECEIVERS:
      return "PlayerCastNoCastReceivers";
    case ErrorCode.ALREADY_CASTING:
      return "PlayerCastAlreadyCasting";
    case ErrorCode.UNEXPECTED_CAST_ERROR:
      return "PlayerCastUnexpectedCastError";
    case ErrorCode.CAST_CANCELED_BY_USER:
      return "PlayerCastCastCanceledByUser";
    case ErrorCode.CAST_CONNECTION_TIMED_OUT:
      return "PlayerCastCastConnectionTimedOut";
    case ErrorCode.CAST_RECEIVER_APP_UNAVAILABLE:
      return "PlayerCastCastReceiverAppUnavailable";
    case ErrorCode.STORAGE_NOT_SUPPORTED:
      return "PlayerStorageStorageNotSupported";
    case ErrorCode.INDEXED_DB_ERROR:
      return "PlayerStorageIndexedDBError";
    case ErrorCode.DEPRECATED_OPERATION_ABORTED:
      return "PlayerStorageDeprecatedOperationAborted";
    case ErrorCode.REQUESTED_ITEM_NOT_FOUND:
      return "PlayerStorageRequestedItemNotFound";
    case ErrorCode.MALFORMED_OFFLINE_URI:
      return "PlayerStorageMalformedOfflineUri";
    case ErrorCode.CANNOT_STORE_LIVE_OFFLINE:
      return "PlayerStorageCannotStoreLiveOffline";
    case ErrorCode.NO_INIT_DATA_FOR_OFFLINE:
      return "PlayerStorageNoInitDataForOffline";
    case ErrorCode.LOCAL_PLAYER_INSTANCE_REQUIRED:
      return "PlayerStorageLocalPlayerInstanceRequired";
    case ErrorCode.NEW_KEY_OPERATION_NOT_SUPPORTED:
      return "PlayerStorageNewKeyOperationNotSupported";
    case ErrorCode.KEY_NOT_FOUND:
      return "PlayerStorageKeyNotFound";
    case ErrorCode.MISSING_STORAGE_CELL:
      return "PlayerStorageMissingStorageCell";
    case ErrorCode.STORAGE_LIMIT_REACHED:
      return "PlayerStorageStorageLimitReached";
    case ErrorCode.DOWNLOAD_SIZE_CALLBACK_ERROR:
      return "PlayerStorageDownloadSizeCallbackError";
    case ErrorCode.MODIFY_OPERATION_NOT_SUPPORTED:
      return "PlayerStorageModifyOperationNotSupported";
    case ErrorCode.INDEXED_DB_INIT_TIMED_OUT:
      return "PlayerStorageIndexedDBInitTimedOut";
    case ErrorCode.CS_IMA_SDK_MISSING:
      return "PlayerAdsCSIMASDKMissing";
    case ErrorCode.CS_AD_MANAGER_NOT_INITIALIZED:
      return "PlayerAdsCSADManagerNotInitialized";
    case ErrorCode.SS_IMA_SDK_MISSING:
      return "PlayerAdsSSIMASDKMissing";
    case ErrorCode.SS_AD_MANAGER_NOT_INITIALIZED:
      return "PlayerAdsSSADManagerNotInitialized";
    case ErrorCode.CURRENT_DAI_REQUEST_NOT_FINISHED:
      return "PlayerAdsCurrentDAIRequestNotFinished";
    case ErrorCode.MT_AD_MANAGER_NOT_INITIALIZED:
      return "PlayerAdsMTAdManagerNotInitialized";
    case ErrorCode.PLAYER_DRM_FETCH_FAILURE:
      return "DrmFetchFailure";
    case SSMError.ssmsetuperror:
    case SSMError.ssmrenewalerror:
    case SSMError.ssmteardownerror:
      return SSMCodeToRawCode(code, suffix)

  }

  return "Unknown"
}